export interface PayPalConfig {
	clientTokenEndpoint: string;
}

/**
 * Payment Gateway Service base for the client token. Same-origin: the F5 rules
 * route `/payment-gateway-service/public/*` to the service in every
 * environment, so `GLOBAL_PAYMENT_ENDPOINT` only needs to be set to override
 * it (e.g. to point at a different host).
 */
const DEFAULT_CLIENT_TOKEN_ENDPOINT = "/payment-gateway-service/public/v1";

export function loadPayPalConfig(): PayPalConfig {
	const { GLOBAL_PAYMENT_ENDPOINT } = process.env;

	return {
		clientTokenEndpoint:
			GLOBAL_PAYMENT_ENDPOINT || DEFAULT_CLIENT_TOKEN_ENDPOINT
	};
}
